export const EXTENSION_TYPE_LABELS = {
  presupuesto: 'Presupuesto máximo',
  vigencia: 'Vigencia'
};

function todayYmd() {
  const today = new Date();
  return [
    today.getFullYear(),
    String(today.getMonth() + 1).padStart(2, '0'),
    String(today.getDate()).padStart(2, '0')
  ].join('-');
}

function parseYmd(value) {
  if (!value) {
    return null;
  }
  const [year, month, day] = String(value).slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) {
    return null;
  }
  return new Date(year, month - 1, day);
}

function formatDateEs(date) {
  if (!date) {
    return '';
  }
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${date.getFullYear()}`;
}

function isVigenciaVencida(contract, metrics) {
  if (typeof metrics.requiere_ampliacion_vigencia === 'boolean') {
    return metrics.requiere_ampliacion_vigencia;
  }

  const end = contract?.fecha_termino_efectiva;
  if (!end) {
    return false;
  }

  return end < todayYmd();
}

function isPresupuestoAgotado(contract, metrics) {
  if (typeof metrics.requiere_ampliacion_presupuesto === 'boolean') {
    return metrics.requiere_ampliacion_presupuesto;
  }

  return Number(metrics.porcentaje_consumido || 0) >= 100;
}

export function neededExtensionTypes(contract) {
  const metrics = contract?.metrics || {};
  const types = [];

  if (isPresupuestoAgotado(contract, metrics)) {
    types.push('presupuesto');
  }
  if (isVigenciaVencida(contract, metrics)) {
    types.push('vigencia');
  }

  return types;
}

export function needsAnyExtension(contract) {
  return neededExtensionTypes(contract).length > 0;
}

export function availableExtensionTypes(contract, requireNeeded = false) {
  const needed = neededExtensionTypes(contract);
  if (needed.length) {
    return needed;
  }
  if (requireNeeded) {
    return [];
  }
  return ['presupuesto', 'vigencia'];
}

export function vigenciaExtensionEndDate(contract, porcentaje) {
  const start = parseYmd(contract?.fecha_inicio);
  const end = parseYmd(contract?.fecha_termino);
  const percent = Number(porcentaje);
  if (!start || !end || Number.isNaN(percent)) {
    return null;
  }

  const diasOriginales = Math.round((end - start) / 86400000);
  const diasExtra = Math.ceil(diasOriginales * (percent / 100));
  const nueva = new Date(end);
  nueva.setDate(nueva.getDate() + diasExtra);
  return nueva;
}

export function vigenciaExtensionInsufficientMessage(contract, porcentaje) {
  const nueva = vigenciaExtensionEndDate(contract, porcentaje);
  if (!nueva) {
    return '';
  }

  const today = parseYmd(todayYmd());
  if (nueva > today) {
    return '';
  }

  const percentLabel = String(porcentaje).replace(/\.0+$/, '');
  return `El ${percentLabel}% de ampliación de vigencia no alcanza para extender la fecha de término después del día de hoy (quedaría en ${formatDateEs(nueva)}).`;
}
